import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { DashboardComponent } from "./components/dashboard/dashboard.component";
import { AdminComponent } from "./layout/admin/admin.component";
import { AuthComponent } from "./layout/auth/auth.component";

import { AuthGuardService as AuthGuard } from "./services/auth-guard.service";

const routes: Routes = [
    {
        path: "",
        component: AdminComponent,
        children: [
            {
                path: "",
                redirectTo: "dashboard",
                pathMatch: "full",
            },
            {
                path: "dashboard",
                component: DashboardComponent,
                data: {
                    title: "Dashboard",
                },
            },
            {
                path: "entidad",
                loadChildren:
                    "./components/entidad/entidad.module#EntidadModule",
            },
            {
                path: "pre-venta",
                loadChildren:
                    "./components/pre-venta/pre-venta.module#PreVentaModule",
            },
            {
                path: "venta",
                loadChildren: "./components/venta/venta.module#VentaModule",
            },
            {
                path: "almacen",
                loadChildren:
                    "./components/almacen/almacen.module#AlmacenModule",
            },
            {
                path: "sistema",
                loadChildren:
                    "./components/sistema/sistema.module#SistemaModule",
            },
            {
                path: "general",
                loadChildren:
                    "./components/general/general.module#GeneralModule",
            },
            {
                path: "compra",
                loadChildren: "./components/compra/compra.module#CompraModule",
            },
            {
                path: "contabilidad",
                loadChildren:
                    "./components/contabilidad/contabilidad.module#ContabilidadModule",
            },
        ],
        canActivate: [AuthGuard],
    },
    {
        path: "",
        component: AuthComponent,
        children: [
            {
                path: "auth",
                loadChildren: "./components/auth/auth.module#AuthModule",
            },
        ],
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { useHash: true })],
    exports: [RouterModule],
})
export class AppRoutingModule {}
